exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2AbfNgln7l-i8rDTrwsR4l {\n  width: auto;\n  border-bottom-left-radius: 0.5rem;\n  float: right;\n  padding: 0.5rem 2rem 0.5rem 2rem;\n  background: rgba(150,150,150,0.3);\n  display: flex;\n  justify-content: flex-end;\n}\n._2AbfNgln7l-i8rDTrwsR4l > * {\n  margin-left: 0.5rem;\n}\n._2AbfNgln7l-i8rDTrwsR4l::after {\n  clear: both;\n}\n", ""]);

// exports
exports.locals = {
	"menu": "_2AbfNgln7l-i8rDTrwsR4l"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/menu.styl
 ** module id = 276
 ** module chunks = 0
 **/